import { h } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import api from '../../api'

export default function QrRedirectPage({ params }) {
  const [error, setError] = useState(null)

  useEffect(() => {
    const code = params && params.code
    if (!code) { setError('Invalid QR code'); return }

    api.getQrCode(code)
      .then(({ destinationUrl }) => {
        window.location.replace(destinationUrl)
      })
      .catch(() => {
        setError('This QR code does not exist or has been removed.')
      })
  }, [])

  if (error) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif', color: '#666' }}>
        <p>{error}</p>
      </div>
    )
  }

  return null
}
